import { Link } from 'react-router-dom';
import { ui, cn } from '../lib/ui';

/** The org settings entry point to payments and donations (docs/Decisions.md D44). */
export default function PaymentsSettingsLink() {
  return (
    <section className={cn(ui.cardFlat, 'mt-6')} aria-labelledby="payments-link-heading">
      <h2 id="payments-link-heading" className={ui.h2}>
        Payments and donations
      </h2>
      <p className="mb-4 text-body-s">
        Connect Stripe so donations are paid to your organization, choose payment options, and set
        your own processing fee.
      </p>
      <div className={ui.row}>
        <Link to="/org/payments" className={ui.btnSecondary}>
          Manage payments
        </Link>
        <Link to="/org/donations" className={ui.btnGhost}>
          View donations
        </Link>
      </div>
    </section>
  );
}
